<template>
    <div>
        <div class="paragraph">
            <div v-if="currentPage == 1">
                <p class="bold">环境影响</p>
                <p class="bold">1、 气候转变：‘全球变暖’</p>
                <p class="indent">温室气体浓度的增加会减少红外线辐射放射到太空外，地球的气候因此需要转变来使吸取和释放辐射的份量达至新的平衡。这转变可包括‘全球性’的地球表面及大气低层变暖，因为这样可以将过剩的辐射排放出外。虽然如此，地球表面温度的少许 上升可能会引发其他的变动，例如：大气层云量及环流的转变。当中某些转变可使地面变暖加剧（正反馈），某些则可令变暖过程减慢（负反馈）。利用复杂的气候模式，‘政府间气候变化专门委员会’在第三份评估报告估计全球的地面平均气温会在2100年上升1.4至5.8℃。这预计已考虑到大气 层中悬浮粒子倾于对地球气候降温的效应与及海洋吸收热能的作用 （海洋有较大的热容量）。但是，还有很多未确定的因素会影响 这个推算结果，例如：未来温室气体排放量的预计、对气候转变的各种反馈过程和海洋吸热的幅度等等。</p>
                <p class="bold">2、 地球上的病虫害增加</p>
                <p class="bold indent">温室效应可使史前致命病毒威胁人类</p>
                <p class="indent">美国科学家近日发出警告，由于全球气温上升令北极冰层溶化，被冰封十几万年的史前致命病毒可能会重见天日，导致全球陷入疫症恐慌，人类生命受到严重威胁。</p>
                <p class="indent">纽约锡拉丘兹大学的科学家在最新一期《科学家杂志》中指出，早前他们发现一种植物病毒TOMV，由于该病毒在大气中广泛扩散，推断在北极冰层也有其踪迹。于是研究员从格陵兰抽取 4块年龄由 500至14万年的冰块，结果在冰层中发现TOMV病毒。研究员指该病毒表层被坚固的蛋白质包围，因此可在逆境生存。</p>
                <p class="indent">这项新发现令研究员相信，一系列的流行性感冒、小儿麻痹症和天花等疫症病毒可能藏在冰块深处，目前人类对这些原始病毒没有抵抗能力，当全球气温上升令冰层溶化时，这些埋藏在冰层千年或更长的病毒便可能会复活，形成疫症。科学家表示，虽然他们不知道这些病毒的生存希望，或者其再次适应地面环境的机会，但肯定不能抹煞病毒卷土重来的可能性。</p>
                <p class="bold">3、 海平面上升</p>
                <p class="indent">假若‘全球变暖’正在发生，有两种过程会导致海平面升高。第一种是海水受热膨胀，令水平面上升。第二种是冰川和格陵兰及南 极洲上的冰块溶解使海洋水份增加。预期由1900年至2100年地球的平均海平面上升幅度介乎0.09米至0.88米之间。
                </p>
            </div>
            <div v-if="currentPage == 2">
                <p class="bold indent">全球暖化南太小岛即将没顶</p>
                <p class="indent">全球暖化使南北极的冰层迅速融化，海平面不断上升，世界银行的一份报告显示，即使海平面只小幅上升1米，也足以导致5600万发展中国家人民沦为难民。而全球第一个被海水淹没的有人居住岛屿即将产生——位于南太平洋国家巴布亚新几内亚的岛屿卡特瑞岛，目下岛上主要道路水深及腰，农地也全变成烂泥巴地。</p>
                <p class="bold">4、 气候反常，海洋风暴增多</p>
                <p class="bold">5、 土地干旱，沙漠化面积增大</p>
                <p class="bold indent">对人类生活的潜在影响</p>
                <p class="bold indent">I、 经济的影响</p>
                <p class="indent">全球有超过一半人口居住在沿海100公里的范围以内，其中大部份住在海港 附近的城市区域。所以，海平面的显著上升对沿岸低洼地区及海岛会造成严重的经济损害，例如：加速沿岸沙滩被海水的冲蚀、 地下淡水被上升的海水推向更远的内陆地方。</p>
                <p class="bold indent">II、 农业的影响</p>
                <p class="indent">实验证明在CO2高浓度的环境下，植物会生长得更快速和高大。但是，‘全球变暖’的结果可会影响大气环流，继 而改变全球的雨量分布与及各大洲表面土壤的含水量。由于未能清楚了解‘全球变暖’对各地区性气候的影响，以致对植物生态所 产生的转变亦未能确定。</p>
                <p class="bold indent">III、 海洋生态的影响</p>
                <p class="indent">沿岸沼泽地区消失肯定会令鱼类，尤其是贝壳类的数量减少。河口水质变咸可会减少淡水鱼的品种数目，相反该地区海洋鱼类的 品种也可能相对增多。至于整体海洋生态所受的影响仍未能清楚知道。</p>
                <p class="bold indent">IV、 水循环的影响</p>
                <p class="indent">全球降雨量可能会增加。但是，地区性降雨量的改变则仍未知道。某些地区可有更多雨量，但有些地区的雨量可能会减少。此外 ，温度的提高会增加水份的蒸发，这对地面上水源的运用带来压力。</p>
            </div>
            <div v-if="currentPage == 3">
                <p class="indent">科学家预测：如果地球表面温度的升高按现在的速度继续发展，到2050年全球温度将上升2－4℃，南北极地冰山将大幅度融化，导致海平面大大上升，一些岛屿国家和沿海城市将淹于水中，其中包括几个著名的国际大城市：纽约，上海，东京和悉尼。</p>
                <p class="bold">相关</p>
                <p class="bold indent">农地积水疟疾肆虐</p>
                <p class="indent">穿着传统服饰向来乐天知命的卡特瑞岛人，几百年来遗世独立，始终保持着传统生活模式，但他们却因人类对环境的破坏造成全球暖化，令他们将面临被海水淹没的命运。卡特瑞岛环保人士保罗塔巴锡说：‘他们已经持续被海洋力量攻击，还有持续不断的洪水，原有的地区都被改变了，被破坏殆尽，几乎所有的地方都被海水淹没了。</p>
                <p class="indent">不堪的是，招致蚊子苍蝇丛生，疟疾肆虐。</p>
                <p class="indent">专家预测，过不了几年，卡特瑞岛将被完全淹没在海里，全岛居民迁村撤离势在必行。亚马逊雨林逐渐消失，而位于南美洲、全世界面积最大的热带雨林——亚马逊雨林正渐渐消失，让全球暖化危机雪上加霜。</p>
                <p class="indent">号称地球之肺的亚马逊雨林涵盖了地球表面5%的面积，制造了全世界20%的氧气及30%的生物物种，由于遭到盗伐和滥垦，亚马逊雨林正以每年7700平方英里的面积消退，相当于一个新泽西州的大小，雨林的消退除了会让全球暖化加剧之外，更让许多只能够生存在雨林内的生物，面临灭种的危机，在过去的40年，雨林已经消失了两成。</p>
                <p class="bold indent">新的冰川期来临</p>
                <p class="indent">球暖化还有个非常严重的后果，就是导致冰川期来临。</p>
                <p class="indent">南极冰盖的融化导致大量淡水注入海洋，海水浓度降低。“大洋输送带”因此而逐渐停止：暖流不能到达寒冷海域；寒流不能到达温暖海域。全球温度降低，另一个冰河时代来临。北半球大部被冰封，一阵接着一阵的暴风雪和龙卷风将横扫大陆。</p>
                <p class="bold red margin-top">最终危害：可能会造成恐龙时代的再次降临！</p>
                <p class="indent">全球暖化南太小岛即将没顶</p>

            </div>
        </div>
        <div class="link-content">
            <div class="bottom">
                <img src="../../../assets/images/shipin.jpg" /> <a href="javascript:void(0)" @click="back">视频版</a>
                <span class="margin-left">页码: </span> <span :class="{ active: currentPage == 1 }" class="page" @click="currentPage = 1">1</span> - <span :class="{ active: currentPage == 2 }" class="page" @click="currentPage = 2">2</span>- <span :class="{ active: currentPage == 3 }" class="page" @click="currentPage = 3">3</span>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TextView",
        data() {
            return {
                currentPage: 1
            }
        },
        methods: {
            back() {
                this.$emit('onIndexChanged',1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .link-content {
        margin-top: 2%;
        margin-left: 10%;
        width: 80%;
        .bottom {
            float: left;
            width: 100%;
            height: 80px;
            img {
                width: 50px;
                height: 50px;
            }
            .paragraph {
                .red {
                    color: #ff0000;
                }
                .margin-top {
                    margin-top: 20px;
                }
            }
            .margin-left {
                margin-left: 40%;
            }
            a, span {
                font-size: 15px;
                color: #008000;
                text-decoration: none;
                cursor: pointer;
            }
            .page {
                padding: 3px 8px;
                border: 1px #aaa solid;
                background: #eee;
                box-shadow: -1px -1px 2px #ccc inset;
                font-weight: bold;
                &.active {
                    background: #4a97d4;
                    border: 1px #175187 solid;
                    color: #fff;
                    box-shadow: -1px -1px 2px #7894bd inset;
                }
            }
        }

    }
</style>